import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthDetailStore } from "../../../stores/useAuthStore";
import { useQueryDataDashboard } from "../api/queries";
import { ROLES_CODE } from "../../../constants/roles";
import useTitle from "../../../hooks/useTitle";

const useDashboard = () => {
    // * stores
    // * stores
    // * stores
    const navigate = useNavigate();
    const detail = useAuthDetailStore((state) => state.detail);

    useTitle("Accueil");

    // * states
    // * states
    // * states
    const [searchParams] = useSearchParams();
    const url_action = searchParams.get("action");

    const [configToast, setConfigToast] = useState({
        visible: url_action === "ADDED_EMPLOYEE",
        content:
            url_action === "ADDED_EMPLOYEE" &&
            "Collaborateur ajouté avec succès",
        level: "success",
    });
    // * Queries & mutations
    const { data, isLoading: isLoadingDashboardData } = useQueryDataDashboard();

    // * assignations
    const myRoles = data?.me?.roles;
    const isManager = myRoles
        ?.map((el) => el?.code)
        .includes(ROLES_CODE?.manager);
    const isRH = myRoles?.map((el) => el?.code).includes(ROLES_CODE?.hr);

    const me = data?.me;
    const monthly_activity = data?.monthly_activity;
    const balances = data?.balances;
    const activities = data?.activities;
    const team = data?.team;
    const key_contacts = data?.key_contacts;
    const team_activities = data?.team_activities;
    const expenses = data?.expenses;
    const current_status = data?.current_status;
    const is_pre_onboarding = data?.current_status?.is_pre_onboarding;
    const tasks = data?.tasks;
    const onboarding_steps = data?.current_status;
    const company_documents = data?.company_documents;
    const company_folder_id = data?.company_folder_id;
    const isExpenseReportActivated =
        detail?.features?.expense_report?.activated; // vérifier si la fonctionnalité est activée

    const canSeeFactsheetCard = me?.status?.id === -3;

    return {
        navigate,
        query: {
            data,
            isLoadingDashboardData,
        },
        roles: {
            isManager,
            isRH,
        },
        toast: {
            configToast,
            setConfigToast,
        },
        dashboardData: {
            me,
            monthly_activity,
            balances,
            activities,
            team,
            key_contacts,
            team_activities,
            expenses,
            current_status,
            is_pre_onboarding,
            tasks,
            onboarding_steps,
            company_documents,
            company_folder_id,
            isExpenseReportActivated,
        },
        canSeeFactsheetCard,
    };
};

export default useDashboard;
